import { Booking } from "@app/core/booking/domain/model/booking";
import { BookingDetail } from "@app/core/booking/domain/model/booking-detail";
import { Observable } from "rxjs";
import { PaymentState } from "@app/core/booking/domain/model/payment-state";
import { PaymentMethodType } from "@app/core/shared/domain/payment-method-type";
import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";

/**
 * Booking repository
 */
export abstract class BookingRepo {
  /**
   * Get all bookings
   */
  abstract getBookings(
    matchSearchCriteria: MatchSearchCriteria,
    token: string
  ): Observable<BookingDetail[]>;
  /**
   * Get booking by id
   */
  abstract getBooking(bookingId: string, token: string): Observable<Booking>;
  /**
   * Create a new booking
   */
  abstract createBooking(booking: Booking, token: string): Observable<void>;
  /**
   * Edit a booking
   */
  abstract editBooking(
    booking: Booking,
    bookingId: string,
    token: string
  ): Observable<void>;
  /**
   * Deletes a booking by id
   */
  abstract deleteBooking(bookingId: string, token: string): Observable<void>;

  /**
   * Apply payment type to a booking
   */
  abstract applyPayment(
    bookingId: string,
    paymentType: string,
    paymentMethodType: PaymentMethodType,
    token: string
  ): Observable<Booking>;

  /**
   * Apply coupon to booking
   */
  abstract applyCoupon(
    bookingId: string,
    couponCode: string,
    token: string
  ): Observable<Booking>;

  /**
   * Unapply coupon to a booking
   */
  abstract unapplyCoupon(
    bookingId: string,
    couponCode: string,
    token: string
  ): Observable<Booking>;

  /**
   * Confirm the payment made of an order to pay a booking
   */
  abstract confirmPaymentDone(
    orderId: string,
    token: string
  ): Observable<PaymentState>;

  /**
   * Join a booking to pay it
   */
  abstract join(
    bookingId: string,
    paymentOption: string,
    token: string
  ): Observable<Booking>;

  abstract updateConsent(
    bookingId: string,
    consent: boolean,
    token: string
  ): Observable<void>;

  abstract setCompetitive(
    pk: string,
    competitive: boolean,
    token: string
  ): Observable<void>;
}
